(function ($) {
  var DESKTOP_MIN = 868;
  var ZOOM_SCALE = 2.5;
  var TAP_ZOOM_SCALE = 2.5;
  var TAP_MAX_MOVE = 15;
  var MIN_SCALE = 1;
  var ZOOM_ACTIVE_THRESHOLD = 1.005;
  var RESET_ANIM_MS = 320;
  var FALLBACK_MAX_SCALE = 24;
  var SCROLL_LOCK_THRESHOLD = 8;

  var mobileSession = {
    $photo: null
  };

  var mobileRafIds = {};
  var resizeTimer = null;
  var mobileZoomStage = null;

  function isMobileZoomStageActive($photo) {
    return !!(mobileZoomStage && mobileZoomStage.$photo && mobileZoomStage.$photo[0] === $photo[0]);
  }

  function getViewportMetrics() {
    return {
      cw: window.innerWidth,
      ch: window.innerHeight
    };
  }

  function refreshStageOriginRect() {
    if (!mobileZoomStage) {
      return null;
    }

    var rect = null;

    if (mobileZoomStage.placeholder) {
      rect = mobileZoomStage.placeholder.getBoundingClientRect();
    } else if (mobileZoomStage.parent) {
      rect = mobileZoomStage.parent.getBoundingClientRect();
    }

    if (rect && rect.width > 0 && rect.height > 0) {
      mobileZoomStage.originRect = {
        left: rect.left,
        top: rect.top,
        width: rect.width,
        height: rect.height
      };
    }

    return mobileZoomStage.originRect;
  }

  function applyStageContainerAtRect($photo, rect, animate) {
    var el = $photo[0];
    var easing = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';
    var sizeTransition = animate
      ? 'top ' + RESET_ANIM_MS + 'ms ' + easing + ', left ' + RESET_ANIM_MS + 'ms ' + easing + ', width ' + RESET_ANIM_MS + 'ms ' + easing + ', height ' + RESET_ANIM_MS + 'ms ' + easing
      : 'none';

    el.style.setProperty('position', 'fixed', 'important');
    el.style.setProperty('inset', 'auto', 'important');
    el.style.setProperty('top', rect.top + 'px', 'important');
    el.style.setProperty('left', rect.left + 'px', 'important');
    el.style.setProperty('right', 'auto', 'important');
    el.style.setProperty('bottom', 'auto', 'important');
    el.style.setProperty('width', rect.width + 'px', 'important');
    el.style.setProperty('height', rect.height + 'px', 'important');
    el.style.setProperty('min-height', '0', 'important');
    el.style.setProperty('max-width', 'none', 'important');
    el.style.setProperty('max-height', 'none', 'important');
    el.style.setProperty('z-index', '9999', 'important');
    el.style.setProperty('transition', sizeTransition, 'important');
  }

  function applyStageContainerResetStyles($photo, origin, animate) {
    applyStageContainerAtRect($photo, origin, animate);
  }

  function applyStageViewportSize($photo, animate) {
    var viewport = getViewportMetrics();
    applyStageContainerAtRect($photo, {
      top: 0,
      left: 0,
      width: viewport.cw,
      height: viewport.ch
    }, animate);
  }

  function setStageBackground($photo, parent) {
    var slideBg = window.getComputedStyle(parent).backgroundColor;
    if (slideBg && slideBg !== 'rgba(0, 0, 0, 0)' && slideBg !== 'transparent') {
      $photo[0].style.setProperty('background-color', slideBg, 'important');
    } else {
      $photo[0].style.setProperty('background-color', '#ffffff', 'important');
    }
  }

  function remapStateForViewportExpansion(state, originRect) {
    var viewport = getViewportMetrics();
    var scaleX = viewport.cw / Math.max(originRect.width, 1);
    var scaleY = viewport.ch / Math.max(originRect.height, 1);

    state.pinchImgX = state.pinchImgX * scaleX;
    state.pinchImgY = state.pinchImgY * scaleY;
    state.x = state.x * scaleX;
    state.y = state.y * scaleY;
  }

  function remapStateForOriginShrink(state, originRect) {
    var viewport = getViewportMetrics();
    var scaleX = originRect.width / Math.max(viewport.cw, 1);
    var scaleY = originRect.height / Math.max(viewport.ch, 1);

    state.pinchImgX = state.pinchImgX * scaleX;
    state.pinchImgY = state.pinchImgY * scaleY;
    state.x = state.x * scaleX;
    state.y = state.y * scaleY;
  }

  function maybeExpandStageToViewport($photo, mid) {
    if (!mobileZoomStage || mobileZoomStage.expanded) {
      return;
    }

    var state = getMobileState($photo);
    if (!isScaleZoomed(state.scale)) {
      return;
    }

    remapStateForViewportExpansion(state, mobileZoomStage.originRect);
    applyStageViewportSize($photo, false);
    mobileZoomStage.expanded = true;

    if (mid) {
      var rect = getPhotoRect($photo);
      state.x = mid.x - rect.left - state.pinchImgX * state.scale;
      state.y = mid.y - rect.top - state.pinchImgY * state.scale;
    }
  }

  function exitMobileZoomStage() {
    if (!mobileZoomStage) {
      return;
    }

    var stage = mobileZoomStage;
    mobileZoomStage = null;
    stage.$photo.removeClass('is-mobile-zoom-stage is-resetting');
    clearStageContainerResetStyles(stage.$photo);
    stage.$photo[0].style.removeProperty('background-color');

    if (stage.parent) {
      if (stage.next) {
        stage.parent.insertBefore(stage.$photo[0], stage.next);
      } else {
        stage.parent.appendChild(stage.$photo[0]);
      }
    }

    if (stage.placeholder && stage.placeholder.parentNode) {
      stage.placeholder.parentNode.removeChild(stage.placeholder);
    }
  }

  function enterMobileZoomStage($photo, mid) {
    if (isDesktop() || isMobileZoomStageActive($photo)) {
      return;
    }

    var state = getMobileState($photo);
    var rect = $photo[0].getBoundingClientRect();
    var parent = $photo.parent()[0];
    var placeholder = document.createElement('div');
    var originRect = {
      left: rect.left,
      top: rect.top,
      width: rect.width,
      height: rect.height
    };

    placeholder.className = 'pdp-mobile-zoom-placeholder';
    placeholder.style.width = rect.width + 'px';
    placeholder.style.height = rect.height + 'px';
    placeholder.setAttribute('aria-hidden', 'true');
    parent.insertBefore(placeholder, $photo[0]);

    mobileZoomStage = {
      $photo: $photo,
      parent: parent,
      next: placeholder,
      placeholder: placeholder,
      originRect: originRect,
      expanded: false
    };

    document.body.appendChild($photo[0]);
    $photo.addClass('is-mobile-zoom-stage');
    applyStageContainerAtRect($photo, originRect, false);
    setStageBackground($photo, parent);
    ensureInnerImagesFill($photo);

    if (mid) {
      state.pinchImgX = (mid.x - originRect.left - state.x) / Math.max(state.scale, MIN_SCALE);
      state.pinchImgY = (mid.y - originRect.top - state.y) / Math.max(state.scale, MIN_SCALE);
    }
  }

  function isDesktop() {
    return window.innerWidth >= DESKTOP_MIN;
  }

  function isActiveSlide($photo) {
    var $slide = $photo.closest('.slick-slide');
    return !$slide.length || $slide.hasClass('slick-active');
  }

  function isSlickArrowTarget(target) {
    return !!(target && target.closest && target.closest('.slider-for .slick-arrow'));
  }

  function getPhotoFromTarget(target) {
    if (!target || !target.closest) {
      return $();
    }

    var el = target.closest('.product-single__photo.pdp-zoom');
    return el ? $(el) : $();
  }

  function getZoomSrc($photo) {
    return $photo.data('zoom-src') || $photo.find('a').attr('href') || '';
  }

  function isHiResReady($photo) {
    var img = $photo.find('.pdp-zoom__hires')[0];
    return !!(img && img.complete && img.naturalWidth);
  }

  function ensureHiRes($photo) {
    var $hiRes = $photo.find('.pdp-zoom__hires');
    if (!$hiRes.length) {
      return $();
    }

    var src = getZoomSrc($photo);
    if (src && $hiRes.data('pdpSrc') !== src) {
      $hiRes.data('pdpSrc', src);
      $hiRes.attr('src', src);
      if (!$photo.hasClass('is-gesturing') && !$photo.hasClass('is-resetting')) {
        $photo.removeClass('is-hires-ready');
      }
    }

    if (isHiResReady($photo)) {
      $photo.addClass('is-hires-ready');
    } else {
      $photo.removeClass('is-hires-ready');
      $hiRes.off('load.pdpZoomReady').one('load.pdpZoomReady', function () {
        $photo.addClass('is-hires-ready');
        if ($photo.hasClass('is-zoomed') && !$photo.hasClass('is-resetting')) {
          applyMobileTransform($photo);
        }
      });
    }

    return $hiRes;
  }

  function preloadActiveHiRes(defer) {
    if (isDesktop()) {
      return;
    }

    var load = function () {
      var $active = $('.slider-for .slick-slide.slick-active .product-single__photo.pdp-zoom');
      if (!$active.length) {
        $active = $('.product-single__photo.pdp-zoom').first();
      }

      $active.each(function () {
        ensureHiRes($(this));
      });
    };

    if (defer) {
      window.setTimeout(load, 2500);
    } else {
      load();
    }
  }

  function photoContainerTransformCss(state, animate) {
    var css = {
      transformOrigin: '0 0',
      transform: 'translate3d(' + state.x + 'px, ' + state.y + 'px, 0) scale(' + state.scale + ')'
    };

    if (animate) {
      css.transition = 'transform ' + RESET_ANIM_MS + 'ms cubic-bezier(0.25, 0.46, 0.45, 0.94)';
    } else {
      css.transition = 'none';
    }

    return css;
  }

  function ensureInnerImagesFill($photo, animateOpacity) {
    var css = {
      width: '100%',
      height: '100%',
      maxWidth: 'none',
      transform: 'none',
      transformOrigin: '',
      transition: 'none'
    };

    $photo.find('.pdp-zoom__preview').css(css);
    $photo.find('.pdp-zoom__hires').css(css);
  }

  function clearPhotoContainerTransform($photo) {
    $photo.css({
      transformOrigin: '',
      transition: '',
      transform: ''
    });

    if ($photo[0]) {
      $photo[0].style.removeProperty('transform');
      $photo[0].style.removeProperty('transform-origin');
    }
  }

  function clearStageContainerResetStyles($photo) {
    var el = $photo[0];
    var props = [
      'position', 'inset', 'top', 'left', 'right', 'bottom', 'width', 'height',
      'min-height', 'max-width', 'max-height', 'z-index', 'transition'
    ];

    props.forEach(function (prop) {
      el.style.removeProperty(prop);
    });
  }

  function lockInnerTransition($photo) {
    if ($photo && $photo.length) {
      ensureInnerImagesFill($photo);
    }
  }

  function clearMobileTransform($el) {
    $el.css({
      width: '',
      height: '',
      maxWidth: '',
      transformOrigin: '',
      transition: '',
      transform: ''
    });
  }

  function cancelMobileTransformRaf($photo) {
    var key = getMobileRafKey($photo);
    if (mobileRafIds[key]) {
      window.cancelAnimationFrame(mobileRafIds[key]);
      mobileRafIds[key] = null;
    }
  }

  function setGallerySwipeEnabled(enabled) {
    var $slider = $('.slider-for');
    if (!$slider.hasClass('slick-initialized')) {
      return;
    }

    try {
      $slider.slick('slickSetOption', 'swipe', enabled, false);
      $slider.slick('slickSetOption', 'draggable', enabled, false);
      $slider.slick('slickSetOption', 'touchMove', enabled, false);
    } catch (err) {
      /* ignore slick option errors */
    }
  }

  function getMobileState($photo) {
    var state = $photo.data('pdpMobileZoom');
    if (!state) {
      state = createMobileState();
      $photo.data('pdpMobileZoom', state);
    }
    return state;
  }

  function createMobileState() {
    return {
      scale: 1,
      x: 0,
      y: 0,
      lastX: 0,
      lastY: 0,
      moved: false,
      pinching: false,
      panning: false,
      didPinch: false,
      startDist: 0,
      startScale: 1,
      pinchImgX: 0,
      pinchImgY: 0,
      scrollIntent: false,
      tapZoomed: false
    };
  }

  function isScaleZoomed(scale) {
    return scale > ZOOM_ACTIVE_THRESHOLD;
  }

  function hasZoomedPhoto() {
    var zoomed = false;
    $('.product-single__photo.pdp-zoom').each(function () {
      var $photo = $(this);
      if ($photo.hasClass('is-zoomed')) {
        zoomed = true;
        return false;
      }
      var state = $photo.data('pdpMobileZoom');
      if (state && isScaleZoomed(state.scale)) {
        zoomed = true;
        return false;
      }
    });
    return zoomed;
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function touchDistance(t0, t1) {
    var dx = t1.clientX - t0.clientX;
    var dy = t1.clientY - t0.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function touchMidpoint(t0, t1) {
    return {
      x: (t0.clientX + t1.clientX) / 2,
      y: (t0.clientY + t1.clientY) / 2
    };
  }

  function getImageNativeSize($photo) {
    var img = $photo.find('.pdp-zoom__hires')[0];

    if (img && img.naturalWidth > 0 && img.naturalHeight > 0) {
      return { w: img.naturalWidth, h: img.naturalHeight };
    }

    img = $photo.find('.pdp-zoom__preview')[0];
    if (img && img.naturalWidth > 0 && img.naturalHeight > 0) {
      var zoomSrc = getZoomSrc($photo);
      var match = zoomSrc.match(/width=(\d+)|_(\d+)x/);
      var targetW = match ? parseInt(match[1] || match[2], 10) : 0;

      if (targetW > img.naturalWidth) {
        var ratio = targetW / img.naturalWidth;
        return {
          w: targetW,
          h: Math.round(img.naturalHeight * ratio)
        };
      }

      return { w: img.naturalWidth, h: img.naturalHeight };
    }

    return { w: 2048, h: 2048 };
  }

  function getMobileMetrics($photo) {
    if (!isDesktop() && isMobileZoomStageActive($photo)) {
      if (mobileZoomStage.expanded) {
        return getViewportMetrics();
      }

      if (mobileZoomStage.originRect) {
        return {
          cw: mobileZoomStage.originRect.width,
          ch: mobileZoomStage.originRect.height
        };
      }
    }

    return {
      cw: $photo.outerWidth(),
      ch: $photo.outerHeight()
    };
  }

  function getPhotoRect($photo) {
    if (!isDesktop() && isMobileZoomStageActive($photo)) {
      if (mobileZoomStage.expanded) {
        return {
          left: 0,
          top: 0,
          width: window.innerWidth,
          height: window.innerHeight
        };
      }

      if (mobileZoomStage.originRect) {
        return {
          left: 0,
          top: 0,
          width: mobileZoomStage.originRect.width,
          height: mobileZoomStage.originRect.height
        };
      }
    }

    return $photo[0].getBoundingClientRect();
  }

  function getMaxPinchScale($photo, cw, ch) {
    var native = getImageNativeSize($photo);

    if (!cw || !ch) {
      return FALLBACK_MAX_SCALE;
    }

    return Math.max(native.w / cw, native.h / ch, MIN_SCALE);
  }

  function clampMobileScale($photo, scale, cw, ch) {
    return clamp(scale, MIN_SCALE, getMaxPinchScale($photo, cw, ch));
  }

  function clampMobilePan(state, cw, ch, $photo) {
    if (isMobileZoomStageActive($photo) && isScaleZoomed(state.scale)) {
      return;
    }

    var scaledW = cw * state.scale;
    var scaledH = ch * state.scale;
    var minX = Math.min(0, cw - scaledW);
    var minY = Math.min(0, ch - scaledH);
    state.x = clamp(state.x, minX, 0);
    state.y = clamp(state.y, minY, 0);
  }

  function getMobileRafKey($photo) {
    return String($photo.data('image-id') || $photo.attr('data-image-id') || $photo.index());
  }

  function scheduleApplyMobileTransform($photo) {
    var key = getMobileRafKey($photo);
    if (mobileRafIds[key]) {
      return;
    }

    mobileRafIds[key] = window.requestAnimationFrame(function () {
      mobileRafIds[key] = null;
      applyMobileTransform($photo);
    });
  }

  function resetMobileZoom($photo, keepState) {
    var state = getMobileState($photo);
    state.scale = 1;
    state.x = 0;
    state.y = 0;
    state.pinching = false;
    state.panning = false;
    state.scrollIntent = false;
    state.tapZoomed = false;
    $photo.removeClass('is-zoomed is-gesturing is-resetting is-mobile-zoom-stage');
    clearStageContainerResetStyles($photo);
    clearPhotoContainerTransform($photo);
    $photo[0].style.removeProperty('background-color');
    ensureInnerImagesFill($photo);

    if (isMobileZoomStageActive($photo)) {
      exitMobileZoomStage();
    }

    if (!keepState) {
      $photo.removeData('pdpMobileZoom');
    }

    if (!hasZoomedPhoto()) {
      setGallerySwipeEnabled(true);
    }
  }

  function completeStageReset($photo) {
    if ($photo.data('pdpResetTimer')) {
      window.clearTimeout($photo.data('pdpResetTimer'));
      $photo.removeData('pdpResetTimer');
    }

    var stage = mobileZoomStage;
    mobileZoomStage = null;

    lockInnerTransition($photo);

    window.requestAnimationFrame(function () {
      if (stage && stage.parent) {
        if (stage.next) {
          stage.parent.insertBefore(stage.$photo[0], stage.next);
        } else {
          stage.parent.appendChild(stage.$photo[0]);
        }
      }

      if (stage && stage.placeholder && stage.placeholder.parentNode) {
        stage.placeholder.parentNode.removeChild(stage.placeholder);
      }

      $photo.removeClass('is-mobile-zoom-stage is-resetting is-zoomed is-gesturing is-hires-ready');
      clearStageContainerResetStyles($photo);
      clearPhotoContainerTransform($photo);
      $photo[0].style.removeProperty('background-color');
      clearMobileTransform($photo.find('.pdp-zoom__preview'));
      clearMobileTransform($photo.find('.pdp-zoom__hires'));
      $photo.removeData('pdpMobileZoom');

      if (!hasZoomedPhoto()) {
        setGallerySwipeEnabled(true);
      }
    });
  }

  function scheduleStageResetComplete($photo) {
    $photo.data(
      'pdpResetTimer',
      window.setTimeout(function () {
        completeStageReset($photo);
      }, RESET_ANIM_MS + 32)
    );
  }

  function animateStageZoomReset($photo) {
    var state = getMobileState($photo);
    var origin = refreshStageOriginRect();

    if (!origin && mobileZoomStage && mobileZoomStage.originRect) {
      origin = mobileZoomStage.originRect;
    }

    cancelMobileTransformRaf($photo);

    if ($photo.data('pdpResetTimer')) {
      window.clearTimeout($photo.data('pdpResetTimer'));
      $photo.removeData('pdpResetTimer');
    }

    if (!origin) {
      completeStageReset($photo);
      return;
    }

    var frozenState = {
      scale: Math.max(state.scale, MIN_SCALE),
      x: state.x,
      y: state.y
    };

    if (mobileZoomStage && mobileZoomStage.expanded) {
      remapStateForOriginShrink(frozenState, origin);
      applyStageContainerAtRect($photo, origin, false);
      mobileZoomStage.expanded = false;
    }

    var startTransform = photoContainerTransformCss(frozenState, false);
    var endTransform = photoContainerTransformCss({ scale: 1, x: 0, y: 0 }, true);

    state.scale = 1;
    state.x = 0;
    state.y = 0;

    ensureInnerImagesFill($photo);
    $photo.removeClass('is-gesturing is-hires-ready').addClass('is-resetting is-zoomed');
    $photo.css(startTransform);

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        void $photo[0].offsetHeight;
        applyStageContainerAtRect($photo, origin, false);
        $photo.css(endTransform);
        $photo[0].style.setProperty(
          'transition',
          'transform ' + RESET_ANIM_MS + 'ms cubic-bezier(0.25, 0.46, 0.45, 0.94)',
          'important'
        );
      });
    });

    scheduleStageResetComplete($photo);
  }

  function animateMobileZoomReset($photo) {
    if (isMobileZoomStageActive($photo) || $photo.hasClass('is-mobile-zoom-stage')) {
      animateStageZoomReset($photo);
      return;
    }

    var state = getMobileState($photo);
    var $preview = $photo.find('.pdp-zoom__preview');
    var $hiRes = $photo.find('.pdp-zoom__hires');
    var metrics = getMobileMetrics($photo);
    var cw = metrics.cw;
    var ch = metrics.ch;

    cancelMobileTransformRaf($photo);

    if ($photo.data('pdpResetTimer')) {
      window.clearTimeout($photo.data('pdpResetTimer'));
      $photo.removeData('pdpResetTimer');
    }

    if (!cw || !ch || !isScaleZoomed(state.scale)) {
      resetMobileZoom($photo);
      return;
    }

    state.scale = 1;
    state.x = 0;
    state.y = 0;

    $photo.removeClass('is-gesturing').addClass('is-resetting is-zoomed');
    ensureInnerImagesFill($photo);
    var resetTransform = photoContainerTransformCss({ scale: 1, x: 0, y: 0 }, true);
    $photo.css(resetTransform);

    $photo.data(
      'pdpResetTimer',
      window.setTimeout(function () {
        $photo.removeData('pdpResetTimer');
        lockInnerTransition($photo);
        window.requestAnimationFrame(function () {
          resetMobileZoom($photo);
        });
      }, RESET_ANIM_MS + 16)
    );
  }

  function applyMobileTransform($photo) {
    if ($photo.hasClass('is-resetting')) {
      return;
    }

    var state = getMobileState($photo);
    var $preview = $photo.find('.pdp-zoom__preview');
    var $hiRes = $photo.find('.pdp-zoom__hires');
    var metrics = getMobileMetrics($photo);
    var cw = metrics.cw;
    var ch = metrics.ch;
    var hiResReady = isHiResReady($photo);

    if (!cw || !ch) {
      return;
    }

    state.scale = clampMobileScale($photo, state.scale, cw, ch);

    if (!isScaleZoomed(state.scale)) {
      if (state.pinching) {
        state.scale = MIN_SCALE;
        state.x = 0;
        state.y = 0;
      } else {
        resetMobileZoom($photo);
        return;
      }
    }

    if (!isDesktop() && isScaleZoomed(state.scale) && !isMobileZoomStageActive($photo)) {
      enterMobileZoomStage($photo, null);
    }

    maybeExpandStageToViewport($photo, null);

    if (isMobileZoomStageActive($photo)) {
      metrics = getMobileMetrics($photo);
      cw = metrics.cw;
      ch = metrics.ch;
    }

    clampMobilePan(state, cw, ch, $photo);
    $photo.addClass('is-zoomed').removeClass('is-resetting');

    if (hiResReady) {
      $photo.addClass('is-hires-ready');
    } else {
      $photo.removeClass('is-hires-ready');
    }

    setGallerySwipeEnabled(false);
    ensureHiRes($photo);
    ensureInnerImagesFill($photo);

    var transform = photoContainerTransformCss(state, false);
    $photo.css(transform);
  }

  function finalizeMobileGesture($photo) {
    var state = getMobileState($photo);

    cancelMobileTransformRaf($photo);
    $photo.removeClass('is-gesturing');
    state.pinching = false;
    state.scrollIntent = false;
    state.panning = false;

    if ($photo.hasClass('is-resetting')) {
      return;
    }

    if (state.didPinch) {
      state.tapZoomed = false;
      animateMobileZoomReset($photo);
      return;
    }

    if (!isScaleZoomed(state.scale)) {
      resetMobileZoom($photo);
      return;
    }

    state.panning = true;
    applyMobileTransform($photo);
  }

  function tapZoomIn($photo, clientX, clientY) {
    if (isDesktop() || $photo.hasClass('is-resetting')) {
      return;
    }

    if ($photo.data('pdpResetTimer')) {
      window.clearTimeout($photo.data('pdpResetTimer'));
      $photo.removeData('pdpResetTimer');
      $photo.removeClass('is-resetting');
    }

    var state = getMobileState($photo);
    var mid = { x: clientX, y: clientY };

    if (!isMobileZoomStageActive($photo)) {
      enterMobileZoomStage($photo, mid);
    }

    var metrics = getMobileMetrics($photo);
    state.scale = clampMobileScale($photo, TAP_ZOOM_SCALE, metrics.cw, metrics.ch);
    state.tapZoomed = true;
    state.didPinch = false;
    state.pinching = false;
    state.panning = true;

    maybeExpandStageToViewport($photo, mid);

    metrics = getMobileMetrics($photo);
    var rect = getPhotoRect($photo);
    state.x = mid.x - rect.left - state.pinchImgX * state.scale;
    state.y = mid.y - rect.top - state.pinchImgY * state.scale;
    clampMobilePan(state, metrics.cw, metrics.ch, $photo);

    $photo.addClass('is-gesturing').removeClass('is-resetting');
    ensureHiRes($photo);
    setGallerySwipeEnabled(false);
    applyMobileTransform($photo);
  }

  function tapZoomOut($photo) {
    var state = getMobileState($photo);
    state.tapZoomed = false;
    animateMobileZoomReset($photo);
  }

  function isTapZoomActive($photo) {
    var state = $photo.data('pdpMobileZoom');
    return !!(
      state &&
      (state.tapZoomed || isScaleZoomed(state.scale)) &&
      (isMobileZoomStageActive($photo) || $photo.hasClass('is-mobile-zoom-stage'))
    );
  }

  function shouldCaptureTouch($photo, state, touchCount) {
    if (touchCount >= 2) {
      return true;
    }

    return isScaleZoomed(state.scale) || state.tapZoomed || $photo.hasClass('is-mobile-zoom-stage');
  }

  function beginPinch($photo, touches) {
    var state = getMobileState($photo);
    var mid = touchMidpoint(touches[0], touches[1]);

    if (!isDesktop() && !isMobileZoomStageActive($photo)) {
      enterMobileZoomStage($photo, mid);
    }

    var rect = getPhotoRect($photo);
    var startScale = Math.max(state.scale, MIN_SCALE);

    state.pinching = true;
    state.panning = false;
    state.scrollIntent = false;
    state.didPinch = true;
    state.startDist = Math.max(touchDistance(touches[0], touches[1]), 1);
    state.startScale = startScale;
    state.pinchImgX = (mid.x - rect.left - state.x) / startScale;
    state.pinchImgY = (mid.y - rect.top - state.y) / startScale;
    $photo.addClass('is-gesturing').removeClass('is-resetting');
    ensureHiRes($photo);
    setGallerySwipeEnabled(false);
  }

  function movePinch($photo, touches) {
    var state = getMobileState($photo);
    var metrics = getMobileMetrics($photo);
    var rect = getPhotoRect($photo);
    var cw = metrics.cw;
    var ch = metrics.ch;
    var mid = touchMidpoint(touches[0], touches[1]);
    var dist = Math.max(touchDistance(touches[0], touches[1]), 1);

    state.scale = clampMobileScale(
      $photo,
      state.startScale * (dist / state.startDist),
      cw,
      ch
    );

    maybeExpandStageToViewport($photo, mid);

    if (isMobileZoomStageActive($photo)) {
      metrics = getMobileMetrics($photo);
      cw = metrics.cw;
      ch = metrics.ch;
      rect = getPhotoRect($photo);
    }

    state.x = mid.x - rect.left - state.pinchImgX * state.scale;
    state.y = mid.y - rect.top - state.pinchImgY * state.scale;
    applyMobileTransform($photo);
  }

  function updatePan($photo, pageX, pageY) {
    var $hiRes = ensureHiRes($photo);
    var img = $hiRes[0];

    if (!img) {
      return;
    }

    var cw = $photo.outerWidth();
    var ch = $photo.outerHeight();
    var offset = $photo.offset();
    var x = Math.max(0, Math.min(pageX - offset.left, cw));
    var y = Math.max(0, Math.min(pageY - offset.top, ch));
    var px = (x / cw) * 100;
    var py = (y / ch) * 100;

    $hiRes.css({
      width: '100%',
      height: '100%',
      maxWidth: 'none',
      transformOrigin: px + '% ' + py + '%',
      transform: 'scale(' + ZOOM_SCALE + ')'
    });
  }

  function resetPan($photo) {
    var $hiRes = $photo.find('.pdp-zoom__hires');

    if ($photo.data('pdpResetTimer')) {
      window.clearTimeout($photo.data('pdpResetTimer'));
      $photo.removeData('pdpResetTimer');
    }

    $photo.removeClass('is-zoomed is-hires-ready is-gesturing is-resetting is-mobile-zoom-stage');
    $photo.removeData('pdpMobileZoom');
    clearStageContainerResetStyles($photo);
    clearPhotoContainerTransform($photo);
    $photo[0].style.removeProperty('background-color');
    ensureInnerImagesFill($photo);
    $photo.find('.pdp-zoom__hires').off('load.pdpZoom load.pdpZoomReady');

    if (isMobileZoomStageActive($photo)) {
      exitMobileZoomStage();
    }

    if (!hasZoomedPhoto()) {
      setGallerySwipeEnabled(true);
    }
  }

  function resetAllPdpZoom() {
    mobileSession.$photo = null;
    exitMobileZoomStage();
    $('.product-single__photo.pdp-zoom').each(function () {
      resetPan($(this));
    });
    setGallerySwipeEnabled(true);
  }

  function markMobileTouchHandled() {
    window.__pdpZoomTouchHandled = Date.now();
  }

  function onMobileTouchStart(e) {
    if (isDesktop() || isSlickArrowTarget(e.target)) {
      mobileSession.$photo = null;
      return;
    }

    var $photo = getPhotoFromTarget(e.target);
    if (!$photo.length || !isActiveSlide($photo) || !e.touches || !e.touches.length) {
      mobileSession.$photo = null;
      return;
    }

    var state = getMobileState($photo);

    if (e.touches.length >= 2) {
      e.preventDefault();
      if ($photo.data('pdpResetTimer')) {
        window.clearTimeout($photo.data('pdpResetTimer'));
        $photo.removeData('pdpResetTimer');
        $photo.removeClass('is-resetting');
      }
      beginPinch($photo, e.touches);
      markMobileTouchHandled();
      return;
    }

    state.pinching = false;
    state.lastX = e.touches[0].clientX;
    state.lastY = e.touches[0].clientY;
    state.moved = false;
    state.scrollIntent = false;

    if (!shouldCaptureTouch($photo, state, e.touches.length)) {
      mobileSession.$photo = $photo;
      return;
    }

    mobileSession.$photo = $photo;

    if (isScaleZoomed(state.scale) || state.tapZoomed) {
      state.panning = true;
      $photo.addClass('is-gesturing');
      setGallerySwipeEnabled(false);
      ensureHiRes($photo);
    } else {
      state.panning = false;
    }
  }

  function onMobileTouchMove(e) {
    if (isDesktop() || !mobileSession.$photo || !e.touches || !e.touches.length) {
      return;
    }

    var $photo = mobileSession.$photo;
    var state = getMobileState($photo);

    if (e.touches.length >= 2) {
      e.preventDefault();
      if (!state.pinching) {
        beginPinch($photo, e.touches);
      }
      movePinch($photo, e.touches);
      state.moved = true;
      markMobileTouchHandled();
      return;
    }

    if (state.pinching) {
      return;
    }

    var touch = e.touches[0];
    var dx = touch.clientX - state.lastX;
    var dy = touch.clientY - state.lastY;

    if (Math.abs(dx) > TAP_MAX_MOVE || Math.abs(dy) > TAP_MAX_MOVE) {
      state.moved = true;
    }

    if (!isScaleZoomed(state.scale) && !state.tapZoomed) {
      var tapDx = touch.clientX - state.lastX;
      var tapDy = touch.clientY - state.lastY;

      if (Math.abs(tapDx) > TAP_MAX_MOVE || Math.abs(tapDy) > TAP_MAX_MOVE) {
        state.moved = true;
        mobileSession.$photo = null;
      }

      return;
    }

    if (!state.scrollIntent && Math.abs(dy) > Math.abs(dx) + SCROLL_LOCK_THRESHOLD) {
      state.scrollIntent = true;
      mobileSession.$photo = null;
      $photo.removeClass('is-gesturing');
      state.panning = false;
      return;
    }

    if (state.scrollIntent) {
      return;
    }

    e.preventDefault();
    state.panning = true;
    $photo.addClass('is-gesturing');
    state.x += dx;
    state.y += dy;
    state.lastX = touch.clientX;
    state.lastY = touch.clientY;
    scheduleApplyMobileTransform($photo);
  }

  function onMobileTouchEnd(e) {
    if (isDesktop() || !mobileSession.$photo) {
      mobileSession.$photo = null;
      return;
    }

    var $photo = mobileSession.$photo;
    var state = getMobileState($photo);
    var stillTouching = e.touches && e.touches.length;

    if (stillTouching >= 2) {
      beginPinch($photo, e.touches);
      return;
    }

    if (state.pinching) {
      if (stillTouching === 1) {
        state.lastX = e.touches[0].clientX;
        state.lastY = e.touches[0].clientY;
        state.pinching = false;
        state.panning = isScaleZoomed(state.scale);
        $photo.removeClass('is-gesturing');
      } else {
        finalizeMobileGesture($photo);
      }
      markMobileTouchHandled();
    } else if (!stillTouching) {
      var wasTap = !state.scrollIntent && !state.moved && !state.pinching && !state.didPinch;

      if (wasTap) {
        if (isTapZoomActive($photo)) {
          tapZoomOut($photo);
        } else {
          tapZoomIn($photo, state.lastX, state.lastY);
        }
        markMobileTouchHandled();
      } else if (!state.scrollIntent && (state.panning || state.moved || state.didPinch)) {
        finalizeMobileGesture($photo);
        markMobileTouchHandled();
      }

      state.didPinch = false;
      state.scrollIntent = false;
      mobileSession.$photo = null;
    }
  }

  function bindMobileCaptureHandlers() {
    if (window.__pdpZoomCaptureBound) {
      return;
    }

    document.addEventListener('touchstart', onMobileTouchStart, { capture: true, passive: false });
    document.addEventListener('touchmove', onMobileTouchMove, { capture: true, passive: false });
    document.addEventListener('touchend', onMobileTouchEnd, { capture: true, passive: false });
    document.addEventListener('touchcancel', onMobileTouchEnd, { capture: true, passive: false });
    window.__pdpZoomCaptureBound = true;
  }

  window.resetAllPdpZoom = resetAllPdpZoom;

  function bindZoom() {
    bindMobileCaptureHandlers();

    $(document)
      .off('.pdpZoom')
      .on('mouseenter.pdpZoom', '.product-single__photo.pdp-zoom', function (e) {
        if (!isDesktop()) {
          return;
        }

        if (window.__pdpZoomSuppressUntil && Date.now() < window.__pdpZoomSuppressUntil) {
          return;
        }

        if ($('.fancybox-container').length) {
          return;
        }

        var $photo = $(this);
        if (isActiveSlide($photo)) {
          ensureHiRes($photo);
          updatePan($photo, e.pageX, e.pageY);
          window.setTimeout(function () {
            $photo.addClass('is-zoomed');
          }, 10);
        }
      })
      .on('mousemove.pdpZoom', '.product-single__photo.pdp-zoom', function (e) {
        if (!isDesktop() || !$(this).hasClass('is-zoomed')) {
          return;
        }

        updatePan($(this), e.pageX, e.pageY);
      })
      .on('mouseleave.pdpZoom', '.product-single__photo.pdp-zoom', function () {
        if (!isDesktop()) {
          return;
        }

        resetPan($(this));
      })
      .on('click.pdpZoom', '.product-single__photo.pdp-zoom, .product-single__photo.pdp-zoom a', function (e) {
        if (isDesktop()) {
          return;
        }

        if (window.__pdpZoomTouchHandled && Date.now() - window.__pdpZoomTouchHandled < 400) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }
      });

    $('.slider-for')
      .off('beforeChange.pdpZoom afterChange.pdpZoom')
      .on('beforeChange.pdpZoom', function () {
        resetAllPdpZoom();
      })
      .on('afterChange.pdpZoom', function () {
        preloadActiveHiRes(true);
      });

    preloadActiveHiRes(true);
  }

  function refreshPdpSliderLayout() {
    $('.slider-for, .slider-nav').each(function () {
      var $slider = $(this);
      if (!$slider.hasClass('slick-initialized')) {
        return;
      }

      try {
        $slider.slick('setPosition');
      } catch (err) {
        /* ignore slick layout errors on resize */
      }
    });
  }

  $(document).ready(bindZoom);
  $(window).on('resize.pdpZoom orientationchange.pdpZoom', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      resetAllPdpZoom();
      refreshPdpSliderLayout();
    }, 200);
  });
  $(document).on('shopify:section:load', bindZoom);
})(jQuery);
